import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import Modal from './../../common/Modal/Modal';
import PageHeader from './../../common/PageHeader/PageHeader';
// components
import ModuleDetails from './ModuleDetails/ModuleDetails';
import QuestionList from './QuestionList/QuestionList';
import ManageQuestion from './ManageQuestion/ManageQuestion';
import Pagination from './../../common/Pagination/Pagination';

const defaultOption = [
	{  
		correct_answer: 'N',
		option_value: ''
	 },
	 {  
		correct_answer: 'N',
		option_value: ''
	 }
]
class ModuleQuestion extends Component {
	constructor(props) {
		super(props);
		this.state = {
			quesModal: false,
			title: '',
			moduleId: this.props.match.params.module_id,
			quesId: '',
			question: '',
			options: [
				{  
					correct_answer: 'N',
					option_value: ''
				 },
				 {  
					correct_answer: 'N',
					option_value: ''
				 }
			],
			reason: '',
			url: '',
			breadcrumb: [
				{
					name: 'Course',
					url: '/course',
					fn: () => this.props.history.go(-2)
				},
				{
					name: this.props.moduleContext.moduleDetails.course_name ?
						this.props.moduleContext.moduleDetails.course_name : 'Module',
					url: '/course_module',
					fn: () => this.props.history.go(-1)
				}
			]	
		}
		this.manageQuestion = this.manageQuestion.bind(this);
		this.onChange = this.onChange.bind(this);
		this.confirmQuestionAction = this.confirmQuestionAction.bind(this);
		this.onChangeOption = this.onChangeOption.bind(this);
		this.onToggleCorrectOption = this.onToggleCorrectOption.bind(this);
		this.onCreateOption = this.onCreateOption.bind(this);
		this.onDestroyOption = this.onDestroyOption.bind(this);
	}

	componentDidMount() {
		const { moduleId } = this.state;
		const { moduleContext, questionContext } = this.props;

		moduleContext.getModuleDetails(moduleId);
		questionContext.getQuestionList(moduleId, 1, 25);
	}

	componentWillUnMount() {
		this.props.questionContext.clearQuestionList();
    	this.props.commonContext.updatePagination();
		this.props.commonContext.updateLoaderMsg();
	}

	componentWillReceiveProps(nextProps) {
		const { title } = this.state;
		const { questionDetails: {question, options, reason, url} } = nextProps.questionContext;

		if ( title === 'edit') {
			const tempOptions = [];
			if (options.length > 0) {
				for (let i = 0; i < options.length; i+=1) {
					let tempObj = options[i];
					delete tempObj['id'];
					tempOptions.push(tempObj);
				}
			}
			this.setState({
				question,
				options: tempOptions,
				reason: reason ? reason : '',
				url: url ? url : ''
			});
		}
	}
	// Modal (question_module)

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.questionContext.getQuestionList(this.state.moduleId, curr_page, size);
	}

		// open Modal (question_module)
			manageQuestion(value, title=null,ques_id=null) {
				const { getQuestionDetails } = this.props.questionContext

				if(value){
					if (title !== 'add') {
						this.setState({ quesId: ques_id });
						if (title === 'edit') {
							getQuestionDetails(ques_id);
						}
					}
				} else {
					this.setState({
						question: '',
						options: [
							{  
								correct_answer: 'N',
								option_value: ''
							 },
							 {  
								correct_answer: 'N',
								option_value: ''
							 }
						],
						reason: '' ,
						url: ''
					});
				}
				this.setState({
					quesModal: value,
					title
				});		
			};

		// modal onchange fields (question_module)
			onChange = (e) => {
				this.setState({[e.target.name]: e.target.value});
			}

			onChangeOption = (e, currentCount) => {
				let tempOptionArray = this.state.options;
				tempOptionArray[currentCount] = {
					...tempOptionArray[currentCount],
					[e.target.name]: e.target.value
				}
				this.setState({ options: tempOptionArray });
			}

			onToggleCorrectOption = (currentCount) => {
				let tempOptionArray = this.state.options;
				let tempCorrectOption = tempOptionArray[currentCount].correct_answer;
				let newCorrectOption = tempCorrectOption === 'N' ? 'Y' : 'N';
				tempOptionArray[currentCount] = {
					...tempOptionArray[currentCount],
					correct_answer: newCorrectOption
				}
				this.setState({ options: tempOptionArray });
			}

			onCreateOption = () => {
				let tempOptionArray = this.state.options;
				let tempObj = {  
					correct_answer: 'N',
					option_value: ''
				}
				tempOptionArray.push(tempObj);
				this.setState({ options: tempOptionArray });
			}

			onDestroyOption = (currentCount) => {
				let tempOptionArray = this.state.options;
				tempOptionArray.splice(currentCount, 1);
				this.setState({ options: tempOptionArray });
			}
		
		// confirm action
			confirmQuestionAction = () => {
				const { quesId, moduleId, question, options, reason , url, title} = this.state;
				const { addQuestion, deleteQuestion, updateQuestionDetails } = this.props.questionContext;

				if (title === 'edit') {
					updateQuestionDetails(quesId, question, options, reason , url, moduleId);
				} else if (title === 'add') {
					addQuestion(question, options, reason , url, moduleId);
				} else if (title === 'delete') {
					deleteQuestion(quesId, moduleId);
				}
			}

	render() {
		const { questionList, questionDetails } = this.props.questionContext;
		const { pagination } = this.props.commonContext;
		const { moduleDetails } = this.props.moduleContext;
		const { breadcrumb, question, options, reason , url, title, quesModal } = this.state;

		let optionEmpty = options.some(item => item.option_value === '');
		let noCorrectOption = options.every(item => item.correct_answer === 'N');

		const disabled = (
			question === '' ||
			optionEmpty ||
			noCorrectOption
		);

		return (
			<div className='ModuleQuestion'>
				<ModuleDetails
					moduleDetails={moduleDetails}
					links={breadcrumb}
					questionsLength={pagination && pagination.numberOfElements ? pagination.numberOfElements : questionList.length}
				/>

				<PageHeader
					title='Questions'
					btnText='Question'                    					
					onAdd={() => this.manageQuestion(true, 'add')}
				/>

				<QuestionList
					manageQuestion={this.manageQuestion}
					questionList={questionList}
				/>
				{pagination && pagination.totalElements > 0 &&
					<Pagination
						totalPage={pagination.totalPages}
						onChangePage={this.onChangePage}
						count={pagination.totalElements}
						first={pagination.first}
						last={pagination.last}
					/>
				}

				{/* Add, Edit, and delete question_module */}
					{quesModal &&
						<Modal
							modalOpen={quesModal}
							toggleModal={this.manageQuestion}
							title={title}
							disabled={title !== 'delete' && disabled}
							confirm={this.confirmQuestionAction}
						>
							<ManageQuestion 
								onChange={(e) => this.onChange(e)}
								question={question}
								onDelete={title === 'delete'}
								options={options}
								reason={reason}
								url={url}
								onChangeOption={this.onChangeOption}
								onToggleCorrectOption={this.onToggleCorrectOption}
								onCreateOption={this.onCreateOption}
								onDestroyOption={this.onDestroyOption}
							/>
						</Modal>
					}
				{/* Add, Edit, and delete question_module */}
			</div>
		);
	}
}


ModuleQuestion.propTypes = {
	history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

ModuleQuestion.defaultProps = {
    history: {},
    match: {}
};

export default ModuleQuestion;



// WEBPACK FOOTER //
// ./components/ModuleQuestion/ModuleQuestion.js